/**
 * BKF collection product carousel: 3D-style product ring driven by JSON in .bkf-collection-carousel__config.
 * Safe to include multiple times per page; only unmouted roots are initialized.
 */
(function () {
  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var BKF_STAR_PATH = 'M18.9652 0L23.4423 13.7792L37.9304 13.7792L26.2093 22.2951L30.6863 36.0742L18.9652 27.5583L7.24407 36.0742L11.7211 22.2951L0 13.7792L14.4881 13.7792L18.9652 0Z';
  var BKF_STAR_VB = '0 0 37.9304 36.0742';
  var BKF_STAR_CLIP_W = 18.9652;
  var BKF_STAR_CLIP_H = 36.0742;
  var starClipIdSeed = 0;

  function renderRatingStars(ratingX10) {
    var normalizedRating = Number(ratingX10);
    if (!isFinite(normalizedRating)) normalizedRating = 0;
    if (normalizedRating < 0) normalizedRating = 0;
    if (normalizedRating > 50) normalizedRating = 50;

    var stars = '';
    var clipPrefix = 'bkf-col-carousel-star-' + (starClipIdSeed += 1);
    for (var i = 1; i <= 5; i += 1) {
      var fullThreshold = i * 10;
      var halfThreshold = fullThreshold - 5;
      if (normalizedRating >= fullThreshold) {
        stars +=
          '<svg class="w-8 h-8 md:w-7 md:h-7" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="' + BKF_STAR_PATH + '" fill="currentColor"/>' +
          '</svg>';
      } else if (normalizedRating >= halfThreshold) {
        var clipId = clipPrefix + '-' + i;
        stars +=
          '<svg class="w-8 h-8 md:w-7 md:h-7" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<defs><clipPath id="' + clipId + '"><rect x="0" y="0" width="' + BKF_STAR_CLIP_W + '" height="' + BKF_STAR_CLIP_H + '"/></clipPath></defs>' +
          '<path d="' + BKF_STAR_PATH + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
          '<path d="' + BKF_STAR_PATH + '" fill="currentColor" clip-path="url(#' + clipId + ')"/>' +
          '</svg>' +
          '';
      } else {
        stars +=
          '<svg class="w-8 h-8 md:w-7 md:h-7" fill="none" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="' + BKF_STAR_PATH + '" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
          '</svg>';
      }
    }

    return stars;
  }

  function createProductHTML(product) {
    var imageHtml = product.image
      ? '<img src="' +
        esc(product.image) +
        '" alt="' +
        esc(product.title) +
        '" class="bkf-col-carousel__slide-image" loading="lazy" />'
      : '<div class="bkf-col-carousel__placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5" class="w-full h-full fill-gray-300" aria-hidden="true"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1v92.5z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h21.6s0 .1.1.1h21.4v-57.8h-72.9v57.7zm2.2-55.6h68.4v42.2l-23.5-22.1c-.6-.5-1.5-.6-2.1-.1l-21.7 18.2-7.3-6.4c-.6-.5-1.5-.6-2.1-.1l-11.7 10v-41.7z"/><path d="M261.9 261.3c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3zm0-8.9c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6 1.6-3.6 3.6-3.6z"/></svg></div>';

    return (
      '<div class="bkf-col-carousel__item carousel-item absolute top-1/2 cursor-pointer max-w-[140px] md:max-w-[243px] w-full" style="left: 50%; transform: translate(-50%, -50%); opacity: 0; pointer-events: none;">' +
      '<div class="w-full relative flex flex-col items-center justify-center">' +
      '<a class="bkf-col-carousel__media-link block w-full" data-bkf-carousel-product-link href="' +
      esc(product.url || '#') +
      '" aria-label="View ' +
      esc(product.title || 'product') +
      '" tabindex="-1">' +
      imageHtml +
      '</a>' +
      '</div></div>'
    );
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Prefer nodes inside this carousel root so we never bind to another section when IDs collide.
   * Falls back to [data-bkf-col-carousel-reviews] for the rating row (see snippets/bkf-rating-row.liquid).
   */
  function getByIdInRoot(root, id) {
    var doc = root.ownerDocument || document;
    var el = doc.getElementById(id);
    if (el && root.contains(el)) return el;
    return null;
  }

  function mount(root, config) {
    var sectionId = config.sectionId;
    var products = config.products || [];
    var track = getByIdInRoot(root, 'track-' + sectionId);
    var titleEl = getByIdInRoot(root, 'productTitle-' + sectionId);
    var container =
      getByIdInRoot(root, 'reviewContainer-' + sectionId) ||
      root.querySelector('[data-bkf-col-carousel-reviews]');
    var shopNowBtn = getByIdInRoot(root, 'shopNowBtn-' + sectionId);
    var prevBtn = getByIdInRoot(root, 'prevBtn-' + sectionId);
    var nextBtn = getByIdInRoot(root, 'nextBtn-' + sectionId);

    if (!track || !titleEl || !shopNowBtn || products.length === 0) return;

    var currentIndex = 0;
    var prevOffsets = [];
    var startX = 0;
    var isDragging = false;

    function updateCarousel() {
      var itemEls = track.querySelectorAll('.bkf-col-carousel__item');
      var isMobile = window.innerWidth < 768;
      var numItems = products.length;

      itemEls.forEach(function (el, index) {
        var offset = ((index - currentIndex) % numItems + numItems) % numItems;
        var product = products[index];
        if (offset > Math.floor(numItems / 2)) {
          offset -= numItems;
        }

        var style = { left: '50%', scale: 0.5, z: 0, op: 0 };

        if (offset === 0) {
          style = { left: '50%', scale: isMobile ? 1.15 : 1.35, z: 30, op: 1 };
        } else if (offset === -1) {
          style = {
            left: isMobile ? '25%' : '33.4%',
            scale: isMobile ? 0.9 : 1,
            z: 20,
            op: isMobile ? 0.65 : 1,
          };
        } else if (offset === 1) {
          style = {
            left: isMobile ? '75%' : '66.6%',
            scale: isMobile ? 0.9 : 1,
            z: 20,
            op: isMobile ? 0.65 : 1,
          };
        } else if (offset === -2) {
          style = {
            left: isMobile ? '-25%' : '16.5%',
            scale: isMobile ? 0.6 : 1,
            z: 10,
            op: isMobile ? 0 : 1,
          };
        } else if (offset === 2) {
          style = {
            left: isMobile ? '125%' : '83.5%',
            scale: isMobile ? 0.6 : 1,
            z: 10,
            op: isMobile ? 0 : 1,
          };
        } else if (offset < -2) {
          style = { left: isMobile ? '-50%' : '0%', scale: isMobile ? 0.5 : 1, z: 0, op: 0 };
        } else if (offset > 2) {
          style = { left: isMobile ? '150%' : '100%', scale: isMobile ? 0.5 : 1, z: 0, op: 0 };
        }

        var prevOffset = prevOffsets[index];

        if (prevOffset !== undefined) {
          if ((prevOffset >= 2 && offset <= -2) || (prevOffset <= -2 && offset >= 2)) {
            el.style.transition = 'none';
            el.style.left = style.left;
            el.style.transform = 'translate(-50%, -50%) scale(' + style.scale + ')';
            el.style.zIndex = String(style.z);
            el.style.opacity = String(style.op);
            void el.offsetWidth;
            el.style.transition = '';
          }
        }

        el.style.left = style.left;
        el.style.transform = 'translate(-50%, -50%) scale(' + style.scale + ')';
        el.style.zIndex = String(style.z);
        el.style.opacity = String(style.op);

        el.style.pointerEvents = style.op > 0 ? 'auto' : 'none';
        var mediaLink = el.querySelector('[data-bkf-carousel-product-link]');
        var isActiveProduct = offset === 0 && style.op > 0;
        if (mediaLink) {
          mediaLink.href = (product && product.url) || '#';
          mediaLink.setAttribute(
            'aria-label',
            'View ' + ((product && product.title) || 'product')
          );
          mediaLink.tabIndex = isActiveProduct && product && product.url ? 0 : -1;
          mediaLink.style.pointerEvents = isActiveProduct ? 'auto' : 'none';
          if (product && product.url) {
            mediaLink.removeAttribute('aria-disabled');
          } else {
            mediaLink.setAttribute('aria-disabled', 'true');
          }
        }

        el.onclick = function () {
          if (offset !== 0 && !isDragging) {
            currentIndex = (currentIndex + offset + numItems) % numItems;
            updateCarousel();
            updateProductInfo(true);
          }
        };

        prevOffsets[index] = offset;
      });
    }

    function updateProductInfo(animate) {
      if (animate === void 0) animate = true;
      var product = products[currentIndex];
      if (!product) return;

      function applyProductCopy() {
        var starsTarget = container
          ? container.querySelector('.bkf-col-carousel__stars') ||
            container.querySelector('[data-bkf-rating-stars]')
          : null;
        var reviewTextTarget = container
          ? container.querySelector('.bkf-col-carousel__review-text') ||
            container.querySelector('.bkf-col-carousel__review-label')
          : null;
        titleEl.textContent = product.title;
        shopNowBtn.href = product.url || '#';
        if (container) {
          container.setAttribute(
            'aria-label',
            product.ratingLabel || '0 out of 5 stars, 0 REVIEWS'
          );
        }
        if (starsTarget) starsTarget.innerHTML = renderRatingStars(product.ratingX10);
        if (reviewTextTarget) reviewTextTarget.textContent = product.reviewText || '0 REVIEWS';
      }

      if (animate && !prefersReducedMotion()) {
        titleEl.style.opacity = '0';
        if (container) container.style.opacity = '0';

        setTimeout(function () {
          applyProductCopy();
          titleEl.style.opacity = '1';
          if (container) container.style.opacity = '1';
        }, 300);
      } else {
        applyProductCopy();
      }
    }

    function moveNext() {
      currentIndex = (currentIndex + 1) % products.length;
      updateCarousel();
      updateProductInfo(true);
    }

    function movePrev() {
      currentIndex = (currentIndex - 1 + products.length) % products.length;
      updateCarousel();
      updateProductInfo(true);
    }

    function handleSwipe(diff) {
      var threshold = 50;
      if (Math.abs(diff) > threshold) {
        if (diff > 0) moveNext();
        else movePrev();
      }
    }

    function setupEventListeners() {
      if (nextBtn) nextBtn.addEventListener('click', moveNext);
      if (prevBtn) prevBtn.addEventListener('click', movePrev);
      track.querySelectorAll('[data-bkf-carousel-product-link]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (link.getAttribute('href') === '#') e.preventDefault();
        });
      });

      window.addEventListener('resize', function () {
        updateCarousel();
      });

      track.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          isDragging = false;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        function () {
          isDragging = true;
        },
        { passive: true }
      );

      track.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        var diff = startX - e.changedTouches[0].clientX;
        handleSwipe(diff);
        setTimeout(function () {
          isDragging = false;
        }, 50);
      });

      track.addEventListener('mousedown', function (e) {
        startX = e.clientX;
        isDragging = false;
      });

      track.addEventListener('mousemove', function (e) {
        if (e.buttons === 1) isDragging = true;
      });

      track.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        var diff = startX - e.clientX;
        handleSwipe(diff);
        setTimeout(function () {
          isDragging = false;
        }, 50);
      });

      track.addEventListener('mouseleave', function () {
        isDragging = false;
      });
    }

    track.innerHTML = products.map(createProductHTML).join('');

    var itemEls = track.querySelectorAll('.bkf-col-carousel__item');
    itemEls.forEach(function (el) {
      el.style.transition = 'none';
    });

    updateCarousel();
    updateProductInfo(false);

    setTimeout(function () {
      itemEls.forEach(function (el) {
        el.style.transition = '';
      });
    }, 50);

    setupEventListeners();

    shopNowBtn.addEventListener('click', function (e) {
      if (shopNowBtn.getAttribute('href') === '#') e.preventDefault();
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-bkf-collection-carousel]:not([data-bkf-carousel-mounted])').forEach(function (root) {
      var cfgEl = root.querySelector('script.bkf-collection-carousel__config[type="application/json"]');
      if (!cfgEl) return;
      try {
        var config = JSON.parse(cfgEl.textContent);
        root.setAttribute('data-bkf-carousel-mounted', '');
        mount(root, config);
      } catch (e) {
        console.warn('BKF Collection Product Carousel: invalid config', e);
      }
    });
  }

  function run() {
    mountAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    mountAll();
  });

  /** Section Rendering API (e.g. product recommendations fetch) replaces innerHTML; remount new carousel roots. */
  if (typeof MutationObserver !== 'undefined') {
    var debounceTimer;
    function addedNodesMayHaveCarousel(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-bkf-collection-carousel]')) return true;
          if (n.querySelector && n.querySelector('[data-bkf-collection-carousel]')) return true;
        }
      }
      return false;
    }
    var mo = new MutationObserver(function (mutations) {
      if (!addedNodesMayHaveCarousel(mutations)) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        mountAll();
      }, 50);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
